import React from 'react';
import { Hero } from './components/Hero';
import { Testimonials } from './components/Testimonials';
import { PainPoints } from './components/PainPoints';
import { ProductIntro } from './components/ProductIntro';
import { Tomes } from './components/Tomes';
import { InsidePreview } from './components/InsidePreview';
import { Tools } from './components/Tools';
import { Transformation } from './components/Transformation';
import { SelfKnowledge } from './components/SelfKnowledge';
import { OfferStack } from './components/OfferStack';
import { Guarantee } from './components/Guarantee';
import { Faq } from './components/Faq';
import { FinalCta } from './components/FinalCta';
import { Footer } from './components/Footer';
import { StickyCta } from './components/StickyCta';
export function App() {
  return <div className="w-full bg-ink font-sans text-ivory" data-id="element-0" data-mp="28tw3qn4zwc1c">
      <Hero data-id="element-1" data-mp="28sbar1ybx15l" />
      <main data-id="element-2" data-mp="23vcjcr61v8b3">
        <PainPoints data-id="element-3" data-mp="23vkuadim43jn" />
        <ProductIntro data-id="element-4" data-mp="23w4c7u89irxo" />
        <Tomes data-id="element-5" data-mp="23utas12ahw9q" />
        <InsidePreview data-id="element-6" data-mp="23t8i6gzjcnei" />
        <Tools data-id="element-7" data-mp="3ijxsgzk2wgo4" />
        <Transformation data-id="element-8" data-mp="3ikh98cxzsz0k" />
        <SelfKnowledge data-id="element-9" data-mp="3ij63w8owfj7c" />
        <Testimonials data-id="element-10" data-mp="3ijpef4c7z5bc" />
        <OfferStack data-id="element-11" data-mp="3mlj8gtrwtb2j" />
        <Guarantee data-id="element-12" data-mp="3ml1234bj9ggw" />
        <Faq data-id="element-13" data-mp="3mkhofzsx1e8o" />
        <FinalCta data-id="element-14" data-mp="3mjzu58ptda3e" />
      </main>
      <Footer data-id="element-15" data-mp="3mj6lg27aoaim" />
      <StickyCta data-id="element-16" data-mp="3rcj7c4kla37o" />
    </div>;
}